import { observer } from "mobx-react-lite";
import { useRouteMatch } from "react-router";
import React, { useContext, useEffect, useRef, useState } from "react";
import { FieldRenderProps } from "react-final-form";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/styles";
import { ListDataSource, LoggerFactory, routerContext } from "lego-gui-lib";
import { Tooltip } from "@material-ui/core";
// @ts-ignore
import SanitizedHTML from "react-sanitized-html";

const useStyles = makeStyles({
  link: {
    color: "inherit",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline"
    }
  },
  withEllipsis: {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
});

export interface PresentationalForeignKeyProps extends FieldRenderProps<any> {
  dataSource: ListDataSource<{}, {}>;
  valueField: string;
  labelField: any;
  routeDestination: string;
}

const log = LoggerFactory.create("foreign key renderer");

export const CustomForeignKeyRenderer = observer(
  (props: PresentationalForeignKeyProps) => {
    const {
      dataSource,
      input,
      labelField,
      routeDestination,
      routeDestinationField,
      valueField,
      asHtml
    } = props;
    const classes = useStyles();
    const [label, setLabel] = useState("");
    const [routeId, setRouteId] = useState("");
    const { homeRoute } = useContext(routerContext);
    const match = useRouteMatch({
      path: `/${homeRoute}/`
    });
    log.debug("match", match);
    useEffect(() => {
      const itemToRender = dataSource.list.find(
        // equality operator used intentionally
        //@ts-ignore
        item => item[valueField] == input.value
      );
      if (itemToRender) {
        if (labelField instanceof Function) {
          setLabel(labelField(itemToRender));
        } else {
          //@ts-ignore
          setLabel(itemToRender[labelField]);
        }
        setRouteId(
          routeDestinationField
            ? //@ts-ignore
              itemToRender[routeDestinationField]
            : //@ts-ignore
              itemToRender[valueField]
        );
      } else {
        setLabel("");
        if (dataSource.list.length > 0) {
          log.warn("Did not find matching entry", input.value);
        }
      }
    }, [dataSource.list, input.value, valueField, labelField, asHtml, label]);
    //@ts-ignore
    return (
      <React.Fragment>
        {match?.url && routeDestination ? (
          <Tooltip title={<SanitizedHTML html={label} />} arrow>
            <Link
              className={classes.link}
              to={`${match.url}/${routeDestination}/${routeId}`}
            >
              <SanitizedHTML html={label} />
            </Link>
          </Tooltip>
        ) : (
          <Tooltip title={<SanitizedHTML html={label} />} arrow>
            <span className={classes.link}>
              <SanitizedHTML html={label} />
            </span>
          </Tooltip>
        )}
      </React.Fragment>
    );
  }
);
